// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05fd335b","453":"888e6107","455":"55433bce","977":"e59e6f0e"}[chunkId] + ".chunk.js";
};